import React, { useState } from 'react';
import { UpdateQty } from '../../pages';
import { array, number, object, string } from 'yup';
import { InventoryController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { inventoryStore, userStore } from '../../stores';
import * as yup from 'yup';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const UpdateQtyContainer = ({ closeModal, setShowSurvey }) => {
    const [loading, setLoading] = useState(false);

    const { needFeedback } = useGetAllActiveReviews(constant.FEEDBACK.STOCKADDUPDATEQUANTITY);

    const validationSchema = () => {
        return object({
            type: string().required(),
            quantity: number()
                .when('type', {
                    is: 'INCREASE',
                    then: number().required('Quantity is required'),
                    otherwise: number(),
                }),
            costPrice: number()
                .when('type', {
                    is: 'INCREASE',
                    then: number().required('Cost price is required'),
                    otherwise: number(),
                }),
            reason: string().max(100, "Should not be more than 100 characters").required('Enter reason'),
            quantityTracker: array(
                object({
                    initialQty: number(),
                    quantity: number().max(yup.ref('initialQty'), ({ max }) => {
                        return `Quantity cannot  be more than ${max}`;
                    }),
                })
            ),
        });
    };

    const onSubmit = async values => {
        let payload

        if (values.type === "INCREASE") {
            payload = {
                type: values.type,
                quantityTracker: [{
                    reason: values.reason,
                    quantity: parseFloat(values.quantity || 0, 10).toFixed(2),
                    costPrice: parseFloat(values.costPrice || 0, 10).toFixed(2),
                }]
            }
        }

        if (values.type === "DECREASE") {
            const updatedQtyTracker = values.quantityTracker.map((obj) => {
                const { user, createdAt, updatedAt, reason, initialQty, ...newObj } = obj;

                newObj.reason = values.reason;
                return newObj;
            })

            const filteredQtyTracker = updatedQtyTracker.filter((obj) => obj.quantity !== '')

            payload = {
                type: values.type,
                quantityTracker: filteredQtyTracker
            }
        }

        setLoading(true);
        const { status, errorMessage } = await InventoryController.updateStocksQuantity(payload);
        if (status === constant.Success) {
            setLoading(false);
            MimaToastUtil.success({
                message: constant.Success,
            });
            closeModal();
            if (needFeedback._id) {
                setShowSurvey(true)
                userStore.setReviewId(needFeedback._id)
            }
            return;
        }
        setLoading(false);
        return MimaToastUtil.error({
            message: errorMessage,
        });
    };

    return (
        <UpdateQty
            closeModal={closeModal}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            selectedStock={inventoryStore.selectedStock}
            loading={loading}
        />
    )
}
export default UpdateQtyContainer;